import React from 'react'
import '../ui.css'
import Button from './button'

const Input = React.forwardRef(function Input(
    {
        id,
        name,
        type = 'text',
        label, // optional accessible label text
        placeholder,
        value,
        onChange,
        autoComplete,
        required = false,
        disabled = false,
        error, // string | undefined
        leftIcon, // optional ReactNode
        rightIcon, // optional ReactNode (if you want custom)
        showPasswordToggle = false, // if true and type="password" => adds eye toggle
        className = '',
        ...props
    },
    ref
) {
    const isPassword = type === 'password'
    const [showPassword, setShowPassword] = React.useState(false)

    const inputType = isPassword && showPasswordToggle ? (showPassword ? 'text' : 'password') : type
    const describedBy = error ? `${id}-error` : undefined

    return (
        <div className={['input', className].filter(Boolean).join(' ')}>
            {label ? (
                <label className="input__label" htmlFor={id}>
                    {label}
                </label>
            ) : (

                <label className="visually-hidden" htmlFor={id}>
                    {name || 'Input'}
                </label>
            )}

            <div className={`input__control ${error ? 'input__control--error' : ''} ${disabled ? 'input__control--disabled' : ''}`}>
                {leftIcon ? <span className="input__icon input__icon--left">{leftIcon}</span> : null}

                <input
                    ref={ref}
                    id={id}
                    name={name}
                    type={inputType}
                    placeholder={placeholder}
                    value={value}
                    onChange={onChange}
                    autoComplete={autoComplete}
                    required={required}
                    disabled={disabled}
                    aria-invalid={!!error}
                    aria-describedby={describedBy}
                    className="input__field"
                    {...props}
                />

                {/* Password toggle uses your Button component (icon variant) */}
                {isPassword && showPasswordToggle ? (
                    <Button
                        variant="icon"
                        type="button"
                        className="input__btn"
                        onClick={() => setShowPassword((v) => !v)}
                        aria-label={showPassword ? 'Hide password' : 'Show password'}
                        aria-pressed={showPassword}
                        title={showPassword ? 'Hide password' : 'Show password'}
                    >
                        {showPassword ? (
                            <i className="uil uil-eye" aria-hidden="true"></i>
                        ) : (
                            <i className="uil uil-eye-slash" aria-hidden="true"></i>
                        )}
                    </Button>
                ) : rightIcon ? (
                    <span className="input__icon input__icon--right">{rightIcon}</span>
                ) : null}
            </div>

            {error ? (
                <p id={`${id}-error`} className="input__error" role="alert">
                    {error}
                </p>
            ) : null}
        </div>
    )
})

export default Input
